<div class="mapa-areas" #mapa>
    <div class="container">
      <h2 class="section-tit1 isotipo-stroke">
        <neo-span-inner-html [contenido]="titulo_tit"></neo-span-inner-html>
      </h2>
      <div class="mapa">
        <div class="mapa-cont">
          <picture>
            <img src="assets/images/mapa-areas.svg" alt=""/>
          </picture>
          <button class="btn1" [ngClass]="{'act': activeLocation < 2}" (click)="establecerUbicacionActiva(1)"></button>
          <button class="btn2" [ngClass]="{'act': activeLocation === 2}" (click)="establecerUbicacionActiva(2)"></button>
          <button class="btn3" [ngClass]="{'act': activeLocation === 3}" (click)="establecerUbicacionActiva(3)"></button>
          <button class="btn4" [ngClass]="{'act': activeLocation === 4}" (click)="establecerUbicacionActiva(4)"></button>
          <button class="btn5" [ngClass]="{'act': activeLocation === 5}" (click)="establecerUbicacionActiva(5)"></button>
          <button class="btn6" [ngClass]="{'act': activeLocation === 6}" (click)="establecerUbicacionActiva(6)"></button>
          <button class="btn7" [ngClass]="{'act': activeLocation === 7}" (click)="establecerUbicacionActiva(7)"></button>
          <button class="btn8" [ngClass]="{'act': activeLocation === 8}" (click)="establecerUbicacionActiva(8)"></button>
          <button class="btn9" [ngClass]="{'act': activeLocation === 9}" (click)="establecerUbicacionActiva(9)"></button>
        </div>
      </div>
      <neo-slider #sliderArea *ngIf="imagesMapa.length" class="slider" [tamanoTitulo]="tamanoTitulo" [id]="'slider-areas'" [slides]="imagesMapa"
        [effect]="'fade'" [paginacion]="false" [handlers]="true" [loop]="true" [autoplay]="false"
        (movimientoSlide)="transicionSlide($event)">
      </neo-slider>
    </div>
</div>